module.exports = __webpack_public_path__ + "static/media/V5.384ebf8e.mp4";